import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, IconButton, Typography } from '@mui/material';
import LinearProgressBar from '../LinearProgress';
import ClearIcon from '@mui/icons-material/Clear';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})

export default function InputFileUpload(props: any) {
  const { handleSelection, name } = props
  const [selectedFile, setSelectedFile] = useState<string>('')
  const [errorSize, setErrorSize] = useState<boolean>(false)
  const [errorType, setErrorType] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const MAX_FILE_SIZE = 5000 // 5MB = 5000KB
  const ALLOWED_TYPES = [
    'text/plain',
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.text'
  ]

  const handleFileChange = (event: any) => {
    if (event.target.files.length > 0) {
      const fileSizeKB: number = Math.floor(event.target.files[0].size / 1000)
      const fileType: string = event.target.files[0].type

      if (!(ALLOWED_TYPES.includes(fileType))) {
        setErrorType(true);
        setSelectedFile('')
        handleSelection(name, {})
        setSuccess(false)
      } else {
        setErrorType(false);
        if (fileSizeKB > MAX_FILE_SIZE) {
          setErrorSize(true);
          setSelectedFile('')
          handleSelection(name, {})
          setSuccess(false)
        } else {
          setErrorSize(false)
          setSelectedFile(event.target.files[0].name)
          loadFile(event.target.files[0])
        }
      }
    }
    event.target.value = ''
  }

  const clearInput = () => {
    setSelectedFile('')
    handleSelection(name, {})
  }

  const loadFile = (fileUpload: File) => {
    if (fileUpload != null) {
      var reader = new FileReader();
      reader.onprogress = function () {
        setSuccess(false)
        setLoading(true)
      }
      reader.onloadend = function (event: any) {
        let fileSubmit = {
          'name': fileUpload.name,
          'size': Math.floor(fileUpload.size / 1000),
          'type': fileUpload.type,
          'content': event.target.result
        }
        handleSelection(name, fileSubmit)
        setTimeout(() => { setLoading(false); setSuccess(true) }, 2000)
      }
      reader.readAsDataURL(fileUpload);
    }
  }

  return (
    <React.Fragment>
      <Button component="label" variant='contained' size='small' startIcon={<CloudUploadIcon />}>
        <p style={{margin: 0, textTransform: 'capitalize'}}>Adjuntar</p>
        <VisuallyHiddenInput accept={ALLOWED_TYPES.join(',')} type="file" onChange={(e) => handleFileChange(e)} />
      </Button>

      {(errorType) &&
        <Typography color='error' variant="body1" paddingY={'1vh'}>
          Los formatos aceptados son: XLSX, PDF, JPG, PNG
        </Typography>
      }

      {!(errorType) && (errorSize) &&
        <Typography color='error' variant="body1" paddingY={'1vh'}>
          El archivo no puede superar los 5MB
        </Typography>
      }

      {(success) && (selectedFile) &&
        <Typography variant="body1" sx={{ fontStyle: 'italic' }} paddingY={'1vh'}>
          {selectedFile}
          <IconButton aria-label="delete" size="small" color='error' onClick={clearInput}>
            <ClearIcon fontSize="medium" />
          </IconButton>
        </Typography>
      }

      {(!success) && (loading) &&
        <Box sx={{ width: '25%', paddingY: '1.5vh' }}>
          <LinearProgressBar />
        </Box>
      }

    </React.Fragment>
  );

}